<template>
  <div v-show="dataLoaded">
    <el-scrollbar height="100%" class="ShowCreateMelkUser">
      <!-- <div class="createMelktitleWrapper">
          <div class="titleContainer">
            <h1 class="createMelkTitle">ویرایش آگهی</h1>

            <div v-if="clickFalse" @click="closeBtnPush" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>

            <div v-if="!clickFalse" @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div> -->
      <div class="createMelkHeader">
        <div class="createMelkHeaderContainer">
          <div class="createMelkHeaderTitle">
            <h1>ویرایش آگهی</h1>
          </div>
          <div v-if="clickFalse" @click="closeBtnPush" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>

          <div v-if="!clickFalse" @click="closeBtn" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
        </div>
      </div>
      <div class="createMelkFormMain">
        <div class="mainContainer">
          <div class="mainHeader">
            <div class="headerContainer">
              <div
                class="stepThumb"
                :class="{ solid: stepUser < 1, colored: stepUser >= 1 }"
              >
                <div class="thumbIconWrapper">
                  <div class="thumbIcon">
                    <i class="fas fa-info-circle"></i>
                  </div>
                </div>
                <div class="stepTitle">ثبت مشخصات</div>
              </div>
              <div
                class="stepThumb"
                :class="{ solid: stepUser < 2, colored: stepUser >= 2 }"
              >
                <div class="thumbIconWrapper">
                  <div class="thumbBar"></div>
                  <div class="thumbIcon">
                    <i class="fas fa-camera"></i>
                  </div>
                </div>
                <div class="stepTitle">انتخاب تصاویر</div>
              </div>
              <div
                class="stepThumb"
                :class="{ solid: stepUser < 3, colored: stepUser >= 3 }"
              >
                <div class="thumbIconWrapper">
                  <div class="thumbBar"></div>
                  <div class="thumbIcon">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                </div>
                <div class="stepTitle">تایید نهایی</div>
              </div>
            </div>
          </div>
          <div class="mainForms">
            <div class="mainFormStep firstStep" v-if="stepUser == 1">
              <div
                class="createMelkFormContainer containerGrid"
                :class="{
                  requestGrid:
                    post_filds && post_filds.main_category == 'request',
                }"
              >
                <div
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'main_category',
                    done: post_filds.main_category !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>دسته بندی</label
                  >
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.main_category"
                    @focus="inputFocusHandler('main_category')"
                    @blur="inputFocusHandler('')"
                    @change="(inputFocusHandler(''), select_main_category())"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.main_category"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="post_filds.main_category == 'request'"
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'request_type',
                    done: post_filds.request_type !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>نوع درخواست</label
                  >
                  <el-select
                    v-model="post_filds.request_type"
                    class="formSelectInput"
                    @focus="inputFocusHandler('request_type')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.request_type"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'category',
                    done: post_filds.category !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>نوع آگهی</label
                  >

                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.category"
                    @focus="inputFocusHandler('category')"
                    @blur="inputFocusHandler('')"
                    @change="(inputFocusHandler(''), select_category())"
                    placeholder=""
                  >
                    <!--                  <el-option-->
                    <!--                      v-for="(v, i) in $store.state.c_set.category"-->
                    <!--                      v-show="post_filds.main_category !== 'rent'"-->
                    <!--                      :key="i"-->
                    <!--                      :value="i"-->
                    <!--                      :label="v"-->
                    <!--                  >-->
                    <!--                  </el-option>-->
                    <el-option value="apartment" label="آپارتمان"> </el-option>
                    <el-option value="villa_house" label="خانه حیاط دار">
                    </el-option>
                    <el-option value="villa" label="ویلا"> </el-option>
                    <el-option value="Administrative" label="اداری">
                    </el-option>

                    <el-option
                      v-if="post_filds.main_category !== 'rent'"
                      value="garden"
                      label="باغ"
                    >
                    </el-option>
                    <el-option
                      v-if="post_filds.main_category !== 'rent'"
                      value="land"
                      label="زمین"
                    >
                    </el-option>
                    <el-option value="commercial" label="تجاری"> </el-option>
                    <el-option value="industrial" label="صنعتی"> </el-option>
                  </el-select>
                </div>
                <div
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'content',
                    done: post_filds.content !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>عنوان آگهی</label
                  >
                  <input
                    v-model="post_filds.content"
                    type="text"
                    maxlength="60"
                    autocomplete="off"
                    @focus="inputFocusHandler('content')"
                    @blur="inputFocusHandler('')"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    (post_filds.category === 'villa_house' ||
                      post_filds.category === 'garden' ||
                      post_filds.category === 'land')
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">متراژ زمین <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.category === 'villa_house' ||
                    post_filds.category === 'garden' ||
                    post_filds.category === 'land'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'land_area',
                    done: front_show.land_area !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>متراژ زمین</span> از</label
                  >
                  <label v-else
                    ><span class="text-danger fs-14">*</span>متراژ زمین</label
                  >
                  <input
                    @input="(event) => setformatPrice(event, 'land_area')"
                    v-model="front_show.land_area"
                    inputmode="numeric"
                    @focus="inputFocusHandler('land_area')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    (post_filds.category === 'villa_house' ||
                      post_filds.category === 'garden' ||
                      post_filds.category === 'land')
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'land_area_max',
                    done: front_show.land_area_max !== '',
                  }"
                >
                  <label><span>متراژ زمین</span> تا</label>
                  <input
                    @input="(event) => setformatPrice(event, 'land_area_max')"
                    v-model="front_show.land_area_max"
                    inputmode="numeric"
                    @focus="inputFocusHandler('land_area_max')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">متراژ <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'building_area',
                    done: front_show.building_area !== '',
                  }"
                >
                  <label v-if="this.post_filds.main_category === 'request'"
                    ><span>متراژ</span> از
                  </label>
                  <label
                    v-else-if="
                      this.post_filds.category === 'apartment' ||
                      this.post_filds.category === 'Administrative' ||
                      this.post_filds.category === 'industrial' ||
                      this.post_filds.category === 'commercial'
                    "
                    ><span class="text-danger fs-14">*</span>متراژ
                  </label>
                  <label v-else
                    ><span class="text-danger fs-14">*</span>متراژ بنا</label
                  >
                  <input
                    v-model="front_show.building_area"
                    inputmode="numeric"
                    @input="(event) => setformatPrice(event, 'building_area')"
                    @focus="inputFocusHandler('building_area')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'building_area_max',
                    done: front_show.building_area_max !== '',
                  }"
                >
                  <label><span>متراژ</span> تا </label>
                  <input
                    v-model="front_show.building_area_max"
                    inputmode="numeric"
                    @input="
                      (event) => setformatPrice(event, 'building_area_max')
                    "
                    @focus="inputFocusHandler('building_area_max')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">سال ساخت <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'completion_date',
                    done: post_filds.completion_date !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>سال ساخت</span> از</label
                  >
                  <label v-else
                    ><span class="text-danger fs-14">*</span>سال ساخت</label
                  >
                  <el-select
                    v-if="post_filds.main_category != 'request'"
                    class="formSelectInput"
                    v-model="post_filds.completion_date"
                    @focus="inputFocusHandler('completion_date')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(year, index) in years"
                      :key="index"
                      :label="year"
                      :value="year"
                    />
                    <el-option :value="'before'" :label="'قبل از سال 1370'" />
                  </el-select>

                  <el-select
                    v-if="post_filds.main_category == 'request'"
                    class="formSelectInput"
                    v-model="post_filds.completion_date"
                    @focus="inputFocusHandler('completion_date')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :value="'new_build'" :label="'نوساز'" />
                    <el-option :value="'1 سال'" :label="'1 سال'" />
                    <el-option :value="'2 سال'" :label="'2 سال'" />
                    <el-option :value="'5 سال'" :label="'5 سال'" />
                    <el-option :value="'10 سال'" :label="'10 سال'" />
                    <el-option :value="'15 سال'" :label="'15 سال'" />
                    <el-option :value="'20 سال'" :label="'20 سال'" />
                    <el-option
                      :value="'بیش از 20 سال'"
                      :label="'بیش از 20 سال'"
                    />
                  </el-select>
                </div>

                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'completion_date_max',
                    done: post_filds.completion_date_max !== '',
                  }"
                >
                  <label><span>سال ساخت</span> تا</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.completion_date_max"
                    @focus="inputFocusHandler('completion_date_max')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :value="'new_build'" :label="'نوساز'" />
                    <el-option :value="'1 سال'" :label="'1 سال'" />
                    <el-option :value="'2 سال'" :label="'2 سال'" />
                    <el-option :value="'5 سال'" :label="'5 سال'" />
                    <el-option :value="'10 سال'" :label="'10 سال'" />
                    <el-option :value="'15 سال'" :label="'15 سال'" />
                    <el-option :value="'20 سال'" :label="'20 سال'" />
                    <el-option
                      :value="'بیش از 20 سال'"
                      :label="'بیش از 20 سال'"
                    />
                  </el-select>
                </div>
                <!-- v-if="this.post_filds.main_category !== 'rent'" -->
                <div
                  v-if="
                    this.post_filds.main_category !== 'rent' &&
                    this.post_filds.request_type !== 'rent'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'doc_type',
                    done: post_filds.doc_type !== '0',
                  }"
                >
                  <label><span class="text-danger fs-14">*</span>نوع سند</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.doc_type"
                    @focus="inputFocusHandler('doc_type')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :key="i" value="0" label="انتخاب کنید">
                    </el-option>
                    <el-option
                      v-for="(v, i) in $store.state.c_set.doc_type"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    post_filds.category === 'commercial' ||
                    post_filds.category === 'industrial'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'width',
                    done: post_filds.width !== '',
                  }"
                >
                  <label>متراژ دهنه ملک</label>
                  <input
                    v-model="post_filds.width"
                    inputmode="numeric"
                    @input="(event) => setformatPrice(event, 'width')"
                    @focus="inputFocusHandler('width')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'bedroom',
                    done: post_filds.bedroom !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>تعداد اتاق</label
                  >
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.bedroom"
                    @focus="inputFocusHandler('bedroom')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :value="0" :label="'بدون اتاق'"></el-option>
                    <el-option
                      v-for="i in 4"
                      :key="i"
                      :value="i"
                      :label="`${i} اتاق`"
                    >
                    </el-option>
                    <el-option :value="5" :label="'بیش از 4 اتاق'"> </el-option>
                  </el-select>
                  <!-- <input
                  v-model="post_filds.bedroom"
                  type="text"
                  @focus="inputFocusHandler('bedroom')"
                  @blur="inputFocusHandler('')"
                /> -->
                </div>
                <div
                  v-if="
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'garden' &&
                    post_filds.category !== 'land'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'parking',
                    done: post_filds.parking !== '',
                  }"
                >
                  <label>پارکینگ</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.parking"
                    @focus="inputFocusHandler('parking')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    (post_filds.main_category == 'trade' &&
                      post_filds.category == 'villa_house') ||
                    post_filds.category == 'garden' ||
                    post_filds.category == 'land'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'passage_width',
                    done: this.post_filds.passage_width !== '',
                  }"
                >
                  <label>عرض کوچه</label>
                  <input
                    v-model="post_filds.passage_width"
                    inputmode="numeric"
                    @input="(event) => setformatPrice(event, 'passage_width')"
                    @focus="inputFocusHandler('passage_width')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    (post_filds.main_category == 'trade' &&
                      post_filds.category == 'villa_house') ||
                    post_filds.category == 'garden' ||
                    post_filds.category == 'land'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'width',
                    done: this.post_filds.width !== '',
                  }"
                >
                  <label>عرض زمین</label>
                  <input
                    v-model="front_show.width"
                    inputmode="numeric"
                    @input="(event) => setformatPrice(event, 'width')"
                    @focus="inputFocusHandler('width')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    class="numberInput"
                  />
                </div>

                <div
                  v-if="
                    post_filds.request_type != 'rent' &&
                    (post_filds.category == 'land' ||
                      (post_filds.category == 'Administrative' &&
                        post_filds.main_category != 'rent'))
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'sub_category',
                    done: post_filds.sub_category !== 0,
                  }"
                >
                  <label
                    ><span class="text-danger fs-14"></span>نوع کاربری</label
                  >
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.sub_category"
                    filterable
                    :clearable="true"
                    @change="inputFocusHandler('')"
                    @focus="inputFocusHandler('sub_category')"
                    @blur="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in front_show.sub_category_list"
                      :key="i"
                      :value="v.value"
                      :label="v.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    post_filds.category == 'villa' &&
                    post_filds.main_category != 'rent' &&
                    post_filds.request_type != 'rent'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'building_license_date',
                    done: post_filds.building_license_date !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14"></span>پروانه ساخت</label
                  >
                  <!-- <DatePicker
                    v-model="post_filds.building_license_date"
                    input-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    :column="1"
                    :modal="true"
                    mode="single"
                  >
                    <template #footer> تاریخ انتخابی: </template>
                  </DatePicker> -->
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.building_license_date"
                    @change="inputFocusHandler('')"
                    @focus="inputFocusHandler('building_license_date')"
                    @blur="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div
                  v-if="
                    post_filds.category == 'villa' &&
                    post_filds.main_category != 'rent' &&
                    post_filds.request_type != 'rent'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'workEnd',
                    done: post_filds.workEnd !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14"></span>پایان کار</label
                  >
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.workEnd"
                    @change="inputFocusHandler('')"
                    @focus="inputFocusHandler('workEnd')"
                    @blur="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div> -->

                <div
                  v-if="
                    post_filds.category !== 'villa_house' &&
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'land' &&
                    post_filds.category !== 'garden'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'elevator',
                    done: post_filds.elevator !== '',
                  }"
                >
                  <label>آسانسور</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.elevator"
                    @focus="inputFocusHandler('elevator')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div
                  v-if="
                    post_filds.main_category !== 'request' &&
                    post_filds.category !== 'villa' &&
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'land' &&
                    post_filds.category !== 'garden'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'storage',
                    done: post_filds.storage !== '',
                  }"
                >
                  <label>انباری</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.storage"
                    @focus="inputFocusHandler('storage')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in $store.state.c_set.public_yes_no"
                      :key="i"
                      :value="i"
                      :label="v"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'request' &&
                    post_filds.category !== 'villa_house' &&
                    post_filds.category !== 'villa' &&
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'land' &&
                    post_filds.category !== 'garden'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'floor',
                    done: post_filds.floor !== '',
                  }"
                >
                  <label>طبقه</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.floor"
                    @focus="inputFocusHandler('floor')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :value="0" :label="'همکف'"></el-option>

                    <el-option
                      v-for="i in 10"
                      :key="i"
                      :value="i"
                      :label="`طبقه ${i}`"
                    >
                    </el-option>
                    <el-option :value="11" :label="'بالاتر از طبقه 10'">
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'request' &&
                    post_filds.category !== 'villa_house' &&
                    post_filds.category !== 'villa' &&
                    post_filds.category !== 'commercial' &&
                    post_filds.category !== 'industrial' &&
                    post_filds.category !== 'land' &&
                    post_filds.category !== 'garden'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'total_floor',
                    done: post_filds.total_floor !== '',
                  }"
                >
                  <label>تعداد طبقات</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.total_floor"
                    @focus="inputFocusHandler('total_floor')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option :value="0" :label="'بدون طبقه'"></el-option>

                    <el-option
                      v-for="i in 10"
                      :key="i"
                      :value="i"
                      :label="`${i} طبقه`"
                    >
                    </el-option>
                    <el-option :value="11" :label="'بیش از 10 طبقه'">
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'request' &&
                    (post_filds.category == 'apartment' ||
                      post_filds.category == 'Administrative')
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'floor_units',
                    done: post_filds.floor_units !== '',
                  }"
                >
                  <label>تعداد واحد</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.floor_units"
                    @focus="inputFocusHandler('floor_units')"
                    @blur="inputFocusHandler('')"
                    @change="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="i in 15"
                      :key="i"
                      :value="i"
                      :label="`${i} واحد`"
                    >
                    </el-option>
                    <el-option :value="16" :label="'بیش از 15 واحد'">
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    front_show.facilities != '' &&
                    post_filds.main_category != 'request'
                  "
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: featuresModal === true,
                    done: post_filds.facilities.length > 0,
                  }"
                >
                  <label>امکانات</label>
                  <div
                    class="featuresUnputBox"
                    @click="showFeaturesModalHnalder"
                  >
                    <Swiper :slides-per-view="'auto'">
                      <SwiperSlide
                        v-for="(v, i) in this.post_filds.facilities"
                        :key="i"
                      >
                        <div class="feautureThumb">
                          {{ v }}
                          <i
                            class="fas fa-xmark"
                            @click="featuresRemoveHandler($event, v)"
                          ></i>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>

                <div
                  class="ChildShowInputFormToUser textareaInput mobileDesc"
                  :class="{
                    focused: isFocus === 'details',
                    done: post_filds.details !== '',
                  }"
                >
                  <label class="textareLabel">توضیحات </label>
                  <textarea
                    v-model="post_filds.details"
                    type="text"
                    rows="5"
                    @focus="inputFocusHandler('details')"
                    @blur="inputFocusHandler('')"
                  ></textarea>
                </div>

                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    post_filds.main_category !== 'trade' &&
                    post_filds.request_type == 'rent'
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">مبلغ رهن(تومان) <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'trade' &&
                    post_filds.request_type == 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'mortgage_price',
                    done: front_show.mortgage_price !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>مبلغ رهن</span> از</label
                  >
                  <label v-else
                    ><span class="text-danger fs-14">*</span>مبلغ رهن
                    (تومان)</label
                  >
                  <input
                    v-model="front_show.mortgage_price"
                    @input="(event) => setformatPrice(event, 'mortgage_price')"
                    @focus="inputFocusHandler('mortgage_price')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    post_filds.request_type == 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'mortgage_price_max',
                    done: front_show.mortgage_price_max !== '',
                  }"
                >
                  <label><span>مبلغ رهن</span> تا</label>
                  <input
                    v-model="front_show.mortgage_price_max"
                    @input="
                      (event) => setformatPrice(event, 'mortgage_price_max')
                    "
                    @focus="inputFocusHandler('mortgage_price_max')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>

                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    post_filds.main_category !== 'trade' &&
                    post_filds.request_type == 'rent'
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">مبلغ اجاره(تومان) <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'trade' &&
                    post_filds.request_type == 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'rent_price',
                    done: front_show.rent_price !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>مبلغ اجاره</span> از</label
                  >
                  <label v-else
                    ><span class="text-danger fs-14">*</span>مبلغ اجاره
                    (تومان)</label
                  >
                  <input
                    v-model="front_show.rent_price"
                    @input="(event) => setformatPrice(event, 'rent_price')"
                    @focus="inputFocusHandler('rent_price')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    post_filds.request_type == 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'rent_price_max',
                    done: front_show.rent_price_max !== '',
                  }"
                >
                  <label><span>مبلغ اجاره</span> تا</label>
                  <input
                    v-model="front_show.rent_price_max"
                    @input="(event) => setformatPrice(event, 'rent_price_max')"
                    @focus="inputFocusHandler('rent_price_max')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>

                <div
                  v-if="
                    post_filds.main_category === 'request' &&
                    post_filds.main_category !== 'rent' &&
                    post_filds.request_type != 'rent'
                  "
                  class="groupLabelWrapper"
                >
                  <div class="groupLabel">قیمت(تومان) <span>*</span></div>
                </div>
                <div
                  v-if="
                    post_filds.main_category !== 'rent' &&
                    post_filds.request_type != 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'total_price',
                    done: front_show.total_price !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>قیمت</span> از</label
                  >
                  <label v-else
                    ><span class="text-danger fs-14">*</span>قیمت (تومان)</label
                  >
                  <input
                    v-model="front_show.total_price"
                    @input="(event) => setformatPrice(event, 'total_price')"
                    @focus="inputFocusHandler('total_price')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>
                <div
                  v-if="
                    post_filds.main_category == 'request' &&
                    post_filds.request_type != 'rent'
                  "
                  class="ChildShowInputFormToUser requestInputHalfGrid"
                  :class="{
                    focused: isFocus === 'total_price_max',
                    done: front_show.total_price_max !== '',
                  }"
                >
                  <label v-if="post_filds.main_category == 'request'"
                    ><span>قیمت</span> تا</label
                  >
                  <input
                    v-model="front_show.total_price_max"
                    @input="(event) => setformatPrice(event, 'total_price_max')"
                    @focus="inputFocusHandler('total_price_max')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>

                <div
                  v-if="post_filds.main_category != 'request'"
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'district',
                    done: post_filds.district !== null,
                  }"
                >
                  <label><span class="text-danger fs-14"></span>منطقه</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.district"
                    filterable
                    :clearable="true"
                    @change="inputFocusHandler('')"
                    @focus="inputFocusHandler('district')"
                    @blur="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in front_show.district_list"
                      :key="i"
                      :value="v.key"
                      :label="v.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="post_filds.main_category == 'request'"
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'districts',
                    done: post_filds.districts !== null,
                  }"
                >
                  <label><span class="text-danger fs-14"></span>منطقه</label>
                  <el-select
                    class="formSelectInput"
                    v-model="post_filds.districts"
                    multiple
                    collapse-tags
                    :multiple-limit="6"
                    collapse-tags-tooltip
                    @change="inputFocusHandler('')"
                    @focus="inputFocusHandler('districts')"
                    @blur="inputFocusHandler('')"
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in front_show.district_list"
                      :key="i"
                      :value="v.key"
                      :label="v.label"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div
                  v-if="post_filds.main_category != 'request'"
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'address',
                    done: post_filds.address !== '',
                  }"
                >
                  <label><span class="text-danger fs-14">*</span>آدرس</label>
                  <input
                    v-model="post_filds.address"
                    @focus="inputFocusHandler('address')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    maxlength="200"
                    autocomplete="off"
                  />
                </div>
                <div
                  v-if="post_filds.main_category == 'request'"
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'name',
                    done: post_filds.name !== '',
                  }"
                >
                  <label><span class="text-danger fs-14">*</span>نام</label>
                  <input
                    v-model="post_filds.name"
                    @focus="inputFocusHandler('name')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    autocomplete="off"
                  />
                </div>
                <div
                  class="ChildShowInputFormToUser"
                  :class="{
                    focused: isFocus === 'contact',
                    done: post_filds.contact !== '',
                  }"
                >
                  <label
                    ><span class="text-danger fs-14">*</span>تلفن تماس</label
                  >
                  <input
                    v-model="post_filds.contact"
                    @focus="inputFocusHandler('contact')"
                    @blur="inputFocusHandler('')"
                    type="text"
                    maxlength="11"
                    autocomplete="off"
                    inputmode="numeric"
                    class="numberInput"
                  />
                </div>
                <div
                  class="archiveFields"
                  v-if="
                    $store.state.auth.role &&
                    $store.state.auth.role != 'customer' &&
                    post_filds.main_category != 'request'
                  "
                >
                  <div class="fieldsHeader">
                    <span>در صورتی که قصد بایگانی کردن فایل را دارید،</span>
                    <span>لطفاً این دو فیلد را تکمیل کنید.</span>
                  </div>
                  <div
                    class="ChildShowInputFormToUser"
                    :class="{
                      focused: isFocus === 'archive_desc',
                      done: post_filds.archive_desc !== '',
                    }"
                  >
                    <label class="customLabel">
                      <span>توضیحات بایگانی</span>
                    </label>
                    <input
                      v-model="post_filds.archive_desc"
                      @focus="inputFocusHandler('archive_desc')"
                      @blur="inputFocusHandler('')"
                      type="text"
                      autocomplete="off"
                    />
                  </div>
                  <div
                    class="ChildShowInputFormToUser"
                    :class="{
                      focused: isFocus === 'owner_tel',
                      done: post_filds.owner_tel !== '',
                    }"
                  >
                    <label class="customLabel">
                      <span>تلفن تماس مالک / همکار</span>
                    </label>
                    <input
                      v-model="post_filds.owner_tel"
                      @focus="inputFocusHandler('owner_tel')"
                      @blur="inputFocusHandler('')"
                      type="text"
                      maxlength="11"
                      autocomplete="off"
                      inputmode="numeric"
                      class="numberInput"
                    />
                  </div>
                </div>
              </div>

              <div class="createMelkFormContainer">
                <div
                  class="ChildShowInputFormToUser textareaInput desktopDesc"
                  :class="{
                    focused: isFocus === 'details',
                    done: post_filds.details !== '',
                  }"
                >
                  <label class="textareLabel">توضیحات </label>
                  <textarea
                    v-model="post_filds.details"
                    type="text"
                    rows="5"
                    @focus="inputFocusHandler('details')"
                    @blur="inputFocusHandler('')"
                  ></textarea>
                </div>
              </div>
              <div
                v-if="post_filds.main_category != 'request'"
                class="createMelkFormContainer formRepeaterInputsWrapper"
              >
                <div class="repeaterInputsTitle">
                  <div class="InputsTitle">مدیریت مسافت مکان‌های عمومی</div>
                  <div class="InputIcon" @click="tooltipHandler">
                    <VsxIcon
                      iconName="InfoCircle"
                      :size="22"
                      color="#0096c7"
                      type="linear"
                    />
                  </div>
                </div>
                <div v-if="showTooltip" class="filterTooltip">
                  در بخش مدیریت مسافت مکان‌های عمومی، می‌توانید مراکز نزدیک به
                  ملک خود را همراه با زمان رسیدن به آن‌ها وارد کنید.
                </div>
                <div class="repeaterInputsContainer">
                  <div class="containerTitle">مسافت پیاده:</div>
                  <div
                    class="containerInputs"
                    v-for="(item, index) in post_filds.walkDistances"
                    :key="'walk-' + index"
                  >
                    <div
                      class="ChildShowInputFormToUser"
                      :class="{
                        focused: isFocus === 'placeWalk-' + index,
                        done:
                          post_filds.walkDistances[index].property_title !== '',
                      }"
                    >
                      <el-autocomplete
                        maxlength="30"
                        :ref="'placeWalk-' + index"
                        v-model="item.property_title"
                        :fetch-suggestions="querySearch"
                        @focus="inputFocusHandler('placeWalk-' + index)"
                        @blur="inputFocusHandler('')"
                        @select="inputFocusHandler('')"
                      />
                      <!-- <input
                        v-model="item.property_title"
                        type="text"
                        maxlength="30"
                        autocomplete="off"
                        @focus="inputFocusHandler('placeWalk-' + index)"
                        @blur="inputFocusHandler('')"
                      /> -->
                      <label>مکان</label>
                    </div>
                    <!-- focused: isFocus === 'timeWalk-' + index, -->
                    <div
                      class="ChildShowInputFormToUser placeWalkInput"
                      :class="{
                        done:
                          post_filds.walkDistances[index].property_time !== '',
                      }"
                    >
                      <input
                        type="text"
                        inputmode="numeric"
                        v-model="item.property_time"
                        maxlength="30"
                        autocomplete="off"
                        @focus="inputFocusHandler('timeWalk-' + index)"
                        @blur="inputFocusHandler('')"
                        @select="inputFocusHandler('')"
                      />
                      <label>زمان تخمینی(دقیقه)</label>
                    </div>
                    <div class="removeItemBtnWrapper">
                      <div class="removeItenBtn" @click="removeWalkItem(index)">
                        <i class="fas fa-minus-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="containerAddBtn" @click="addWalkItem">
                    <div class="btnIcon">
                      <i class="fas fa-plus-circle"></i>
                    </div>
                    <div class="btnTitle">افزودن مکان جدید</div>
                  </div>
                </div>
                <div class="repeaterInputsContainer">
                  <div class="containerTitle">مسافت با وسیله نقلیه:</div>
                  <div
                    class="containerInputs"
                    v-for="(item, index) in post_filds.driveDistances"
                    :key="'drive-' + index"
                  >
                    <div
                      class="ChildShowInputFormToUser"
                      :class="{
                        focused: isFocus === 'placeDrive-' + index,
                        done:
                          post_filds.driveDistances[index].property_title !==
                          '',
                      }"
                    >
                      <label>مکان</label>
                      <!-- <el-autocomplete
                        maxlength="30"
                        :ref="'placeDrive-' + index"
                        v-model="item.property_title"
                        :fetch-suggestions="querySearch"
                        @focus="inputFocusHandler('placeDrive-' + index)"
                        @blur="inputFocusHandler('')"
                        @select="inputFocusHandler('')"
                      /> -->
                      <input
                        type="text"
                        v-model="item.property_title"
                        maxlength="30"
                        autocomplete="off"
                        @focus="inputFocusHandler('placeDrive-' + index)"
                        @blur="inputFocusHandler('')"
                      />
                    </div>
                    <!-- focused: isFocus === 'timeDrive-' + index, -->
                    <div
                      class="ChildShowInputFormToUser placeWalkInput"
                      :class="{
                        done:
                          post_filds.driveDistances[index].property_time !== '',
                      }"
                    >
                      <input
                        type="text"
                        inputmode="numeric"
                        v-model="item.property_time"
                        maxlength="30"
                        autocomplete="off"
                        @focus="inputFocusHandler('timeDrive-' + index)"
                        @blur="inputFocusHandler('')"
                      />
                      <label>زمان تخمینی(دقیقه)</label>
                    </div>
                    <div class="removeItemBtnWrapper">
                      <div
                        class="removeItenBtn"
                        @click="removeDriveItem(index)"
                      >
                        <i class="fas fa-minus-circle"></i>
                      </div>
                    </div>
                  </div>
                  <div class="containerAddBtn" @click="addDriveItem">
                    <div class="btnIcon">
                      <i class="fas fa-plus-circle"></i>
                    </div>
                    <div class="btnTitle">افزودن مکان جدید</div>
                  </div>
                </div>
              </div>
              <div class="createMelkFormContainer">
                <div class="createMelkFormSwitches">
                  <div class="switchBox">
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.showphone }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.showphone"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">نمایش شماره تماس</div>
                  </div>
                  <div class="switchBox">
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.fast }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.fast"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">آگهی فوری</div>
                  </div>

                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category !== 'rent' &&
                      post_filds.main_category !== 'request' &&
                      post_filds.request_type !== 'rent'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.exchangeable }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.exchangeable"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">قابل معاوضه</div>
                  </div>

                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category === 'rent' &&
                      post_filds.category != 'villa'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.convertable }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.convertable"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">قابل تبدیل</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category === 'rent' &&
                      post_filds.category != 'villa' &&
                      post_filds.category != 'Administrative' &&
                      post_filds.category != 'commercial' &&
                      post_filds.category != 'industrial'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.furnished }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.furnished"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">مبله</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category === 'rent' &&
                      post_filds.category != 'villa' &&
                      post_filds.category != 'Administrative' &&
                      post_filds.category != 'commercial' &&
                      post_filds.category != 'industrial'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.student }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.student"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">دانشجو</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category === 'rent' &&
                      post_filds.category != 'villa' &&
                      post_filds.category != 'Administrative' &&
                      post_filds.category != 'commercial' &&
                      post_filds.category != 'industrial'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.single }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.single"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">مجرد</div>
                  </div>

                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category != 'rent' &&
                      post_filds.category == 'apartment' &&
                      post_filds.request_type != 'rent' &&
                      post_filds.main_category == 'request' &&
                      post_filds.request_type != 'buy'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.reBuild }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.reBuild"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">بازسازی شده</div>
                  </div>

                  <div
                    class="switchBox"
                    v-if="
                      post_filds.main_category === 'request' &&
                      post_filds.request_type === 'rent'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.pet }"
                    >
                      <input type="checkbox" v-model="post_filds.feature.pet" />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">حیوان خانگی</div>
                  </div>

                  <div
                    class="switchBox"
                    v-if="
                      ((post_filds.main_category === 'request' &&
                        post_filds.request_type === 'rent') ||
                        post_filds.main_category === 'rent') &&
                      post_filds.category == 'villa'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.dayli_rent }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.dayli_rent"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">اجاره روزانه</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.category === 'land' ||
                      post_filds.category === 'garden'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.inbaft }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.inbaft"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">داخل بافت</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.category === 'land' ||
                      post_filds.category === 'garden'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.outbaft }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.outbaft"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">خارج بافت</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="post_filds.category === 'villa_house'"
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.pilot }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.pilot"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">روی پیلوت</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="post_filds.category === 'villa_house'"
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.seatBottom }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.seatBottom"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">کف کرسی</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.category === 'villa_house' &&
                      post_filds.main_category == 'trade'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.liveable }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.liveable"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">قابل سکونت</div>
                  </div>
                  <div
                    class="switchBox"
                    v-if="
                      post_filds.category == 'villa' &&
                      post_filds.main_category != 'rent' &&
                      post_filds.request_type != 'rent'
                    "
                  >
                    <div
                      class="customCheckBox"
                      :class="{ checked: post_filds.feature.workEnd }"
                    >
                      <input
                        type="checkbox"
                        v-model="post_filds.feature.workEnd"
                      />
                      <div class="checkedTick">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                    <div class="switchTitle">پایان کار</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mainFormStep secondStep" v-if="stepUser == 2">
              <div class="formPicUploadWrapper">
                <input
                  type="file"
                  id="uploadImage"
                  multiple
                  accept="image/*"
                  @change="handleFileChange"
                  class="file-input"
                />
                <div class="picUploadForm">
                  <div
                    class="uploadFormContent"
                    for="uploadImage"
                    @dragover.prevent
                    @drop.prevent="handleDrop"
                  >
                    <div class="contentHeader">
                      <div class="uploadPic">
                        <i
                          class="fas fa-cloud-upload-alt text-4xl text-gray-400"
                        ></i>
                      </div>
                    </div>
                    <div class="contentMain">
                      <div class="mainDesc">تصاویر را اینجا بنداز</div>
                      <div class="mainSubtitle">یا</div>
                    </div>
                    <label for="uploadImage" class="contentFooter">
                      <div class="uploadBtn">افزودن تصویر</div>
                    </label>
                  </div>
                </div>
                <div class="picUploadedWrapper">
                  <label for="uploadImage" class="mobileUploadForm">
                    <div class="formIcon">
                      <i class="fas fa-plus"></i>
                    </div>
                    <div class="formTitle">افزودن عکس</div>
                  </label>
                  <div
                    class="uploadedThumb noUploadedThumb"
                    v-if="front_show.images.length === 0"
                  >
                    <div class="thumbPic">
                      <div class="noUploadPic">
                        <i class="fas fa-image"></i>
                        <p>تصویری آپلود نشد</p>
                      </div>
                    </div>
                    <div class="thumbContent">
                      <div class="contentBtn editBtn">
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                        <div class="btnTitle">ویرایش</div>
                      </div>
                      <div class="contentBtn deleteBtn">
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                        <div class="btnTitle">حذف</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="uploadedThumb"
                    v-for="(image, index) in front_show.images"
                    :key="index"
                  >
                    <div class="thumbPic">
                      <img :src="image" alt="Preview" class="preview-image" />
                    </div>
                    <div class="thumbContent">
                      <div
                        class="contentBtn editBtn"
                        @click="setEditIndex(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                        <div class="btnTitle">ویرایش</div>
                      </div>
                      <div
                        class="contentBtn deleteBtn"
                        @click="removeImage(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                        <div class="btnTitle">حذف</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mainFormStep thirdStep" v-if="stepUser == 3">
              <div class="mapStepWrapper">
                <div class="mapStepMain">
                  <div class="mapSearchGroup">
                    <div class="sreachInputIcon" @click="searchLocation">
                      <i class="fas fa-search"></i>
                    </div>
                    <input
                      type="search"
                      class="searchInput"
                      inputmode="search"
                      v-model="searchQuery"
                      enterkeyhint="search"
                      placeholder="جستجوی آدرس"
                      @keyup.enter="searchLocation"
                    />
                  </div>
                  <div id="map" class="leaflet-map"></div>
                </div>
                <div class="mapStepFooter">
                  <div class="mapAddressInput">
                    <input
                      type="text"
                      class="addressInput"
                      v-model="post_filds.address"
                      placeholder="موقعیت مکانی را تعیین کنید"
                    />
                  </div>
                  <div div class="showExtactLocOption">
                    <div class="optionInput">
                      <el-switch v-model="notShowMap" />
                    </div>
                    <div class="optionTitle">موقعیت دقیق نمایش داده نشود</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mainFormStep fourthStep" v-if="stepUser == 4">
              <div class="successedMessageWrapper">
                <div class="messageThumb">
                  <div class="thumbHeader">
                    <div class="successedIcon">
                      <i class="fas fa-check"></i>
                    </div>
                  </div>
                  <div class="thumbMain">
                    <div class="mainTitle">ویرایش آگهی با موفقیت انجام شد!</div>
                    <div class="mainSubtitle">
                      آگهی شما با موفقیت ویرایش شد و در لیست آگهی‌ها قابل مشاهده
                      می‌باشد.
                    </div>
                  </div>
                  <div class="thumbFooter">
                    <div class="footerButtonWrapper">
                      <div class="footerButton btnBack" @click="closeBtn">
                        <div class="btnTitle">دفاتر آگهی</div>
                      </div>
                      <div
                        @click="showCategoryHandler"
                        class="footerButton btnShow"
                      >
                        <div class="btnTitle">همه آگهی‌ها</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mainFooter" v-if="stepUser < 4">
            <div class="footerBtnWrapper">
              <div class="footerBackBtn">
                <div
                  class="backBtn footerBtn"
                  v-if="stepUser === 1"
                  @click="closeBtn"
                >
                  <div class="footerBtnIcon">
                    <i class="fa-solid fa-arrow-right"></i>
                  </div>
                  <div class="footerBtnTitle">برگشت</div>
                </div>
                <div
                  class="backBtn footerBtn"
                  v-if="stepUser > 1 && stepUser < 4"
                  @click="historyBackHanlder"
                >
                  <div class="footerBtnIcon">
                    <i class="fa-solid fa-arrow-right"></i>
                  </div>
                  <div class="footerBtnTitle">قبلی</div>
                </div>
              </div>
              <div class="footerNextBtn">
                <div
                  class="nextBtn footerBtn"
                  v-if="stepUser < 3 && !btn_loading"
                  @click="StepClickBox"
                >
                  <div class="footerBtnTitle">بعدی</div>
                  <div class="footerBtnIcon">
                    <i class="fa-solid fa-arrow-left"></i>
                  </div>
                </div>
                <div
                  class="nextBtn footerBtn loadingBtn"
                  v-if="btn_loading"
                  @click="StepClickBox"
                >
                  <span class="loading"></span>
                </div>
                <div
                  class="nextBtn footerBtn"
                  v-if="stepUser == 3 && !btn_loading"
                  @click="StepClickBox"
                >
                  <div class="footerBtnTitle">ویرایش آگهی</div>
                  <div class="footerBtnIcon">
                    <i class="fa-solid fa-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <!-- <el-dialog
      v-model="featuresModal"
      title="امکانات"
      :close-on-click-modal="true"
      :show-close="true"
      @close="featuresModal = false"
      :width="dialogWidth"
      class="featuresDialog"
    >
      <el-scrollbar height="304" style="padding: 0 16px; padding-bottom: 16px">
        <div class="featuresListContainer">
          <div
            v-for="(v, i) in front_show.facilities"
            :key="i"
            class="featuresBtn"
            :class="{ selected: post_filds.facilities.includes(v) }"
            @click="featuresSelectHandler(v)"
          >
            {{ v }}
            <span>
              <i
                class="fas fa-xmark"
                @click.stop="featuresRemoveHandler($event, v)"
              ></i>
            </span>
          </div>
        </div>

        <div class="featuresSubmitBtn" @click="featuresModal = false">
          ثبت امکانات
        </div>
      </el-scrollbar>
    </el-dialog> -->
    <div class="featuresControl" :class="{ active: featuresModal }">
      <div class="controlOverlay" @click="historyBackHanlder"></div>
      <div class="controlContent">
        <div class="contentHandler">
          <div class="handlerThumb"></div>
        </div>
        <div class="contentContainer">
          <div class="containerHeader">
            <div class="headerTitleWrapper">
              <div class="headerTitle">امکانات</div>
              <div class="headerDesc">
                <span
                  v-if="
                    post_filds.facilities && post_filds.facilities.length > 0
                  "
                >
                  {{ post_filds.facilities.length }} مورد انتخاب شده
                </span>
                <span v-else>موردی انتخاب نشده</span>
              </div>
            </div>
          </div>
          <div class="containerMain">
            <div class="mainFeatures">
              <button
                class="featuresThumb"
                v-for="(v, i) in front_show.facilities"
                :key="i"
                :class="{ selected: post_filds.facilities.includes(v) }"
                @click="featuresSelectHandler(v)"
              >
                <span>{{ v }}</span>
              </button>
            </div>
          </div>
          <div class="containerFooter">
            <button class="footerSubmit" @click="historyBackHanlder">
              تایید
              <span
                v-if="post_filds.facilities && post_filds.facilities.length > 0"
                >({{ post_filds.facilities.length }})</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Compressor from "compressorjs";
import axios from "axios";
import { toast } from "vue3-toastify";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
// import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
// import "@majidh1/jalalidatepicker";
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import L from "leaflet";
import "leaflet.markercluster";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

try {
  if (maplibregl) {
    maplibregl.setRTLTextPlugin("./js/mapbox-gl-rtl-text.js", null, true);
  }
} catch (_e) {
  console.error(_e);
}

export default {
  name: "editMelk",
  props: {
    postId: String,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isFocus: "",
      btn_loading: false,
      // featuresModal: false,
      isLoading: true,
      clickFalse: false,
      // stepUser: 1,
      editIndex: null,
      map: null,
      mapInitialized: false,
      mapInitStarted: false,
      marker: null,
      searchQuery: "",
      defaultCenter: [36.5663854, 52.6707147],
      defaultZoom: 14,
      years: [],
      exactLocation: false,
      notShowMap: false,
      post_filds: {
        content: "",
        request_type: "buy",
        name: "",
        completion_date: "",
        completion_date_max: "",
        doc_type: "0",
        main_category: "trade",
        category: "apartment",
        sub_category: "",
        building_area: "",
        building_area_max: "",
        land_area: "",
        land_area_max: "",
        floor: "",
        mortgage_price: 0,
        mortgage_price_max: 0,
        rent_price: 0,
        rent_price_max: 0,
        meter_price: 0,
        total_price: 0,
        total_price_max: 0,
        width: "",
        bedroom: "",
        floor_units: "",
        total_floor: "",
        parking: "",
        elevator: "",
        building_license_date: "",
        storage: "",
        passage_width: "",
        district: null,
        districts: [],
        state: 26,
        city: 317,
        images: [],
        new_images: [], // برای تصاویر جدید یا جایگزین
        address: "",
        mapAddress: "",
        latitude: "",
        longitude: "",
        details: "",
        contact: "",
        facilities: [],
        status: "pending",
        feature: {
          showphone: false,
          exchangeable: false,
          convertable: false,
          furnished: false,
          student: false,
          single: false,
          fast: false,
          showmap: true,
          reBuild: false,
          pet: false,
          dayli_rent: false,
          inbaft: false,
          outbaft: false,
          pilot: false,
          seatBottom: false,
          liveable: false,
          workEnd: false,
        },
        walkDistances: [],
        driveDistances: [],
        archive_desc: "",
        owner_tel: "",
      },
      front_show: {
        facilities: [],
        sub_category_list: [],
        building_area: "",
        building_area_max: "",
        passage_width: "",
        land_area: "",
        land_area_max: "",
        mortgage_price: 0,
        mortgage_price_max: 0,
        rent_price: 0,
        rent_price_max: 0,
        meter_price: 0,
        total_price: 0,
        total_price_max: 0,
        width: "",
        district_list: [],
        images: [],
      },
      placeOptions: ["مسجد", "مدرسه", "بازار", "پارک"],
      dialogWidth: "600px",
      dataLoaded: false,
      showTooltip: false,
      branchInfo: null,
      previousRote: null,
    };
  },
  mounted() {
    this.previousRote = window.history.state.back;
    if (this.$route.path == "/submit-house") {
      this.ShowToUser();
      this.clickFalse = true;
    }
    const bInfo = localStorage.getItem("branchinof");
    if (bInfo) {
      this.branchInfo = JSON.parse(bInfo);
    }
    if (this.stepUser != 1) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          step: 1,
        },
      });
    }

    this.load_postInfo();
    this.select_category();
    window.addEventListener("resize", this.handleResize);

    window.jalaliDatepicker.startWatch({
      maxDate: "today",
    });

    if (this.stepUser === 3) {
      this.$nextTick(() => {
        this.initMap();
      });
    }
    this.getJalaliYears();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    try {
      if (this.map) {
        this.map.off("click", this.handleMapClickLeaflet);
        if (this.marker) this.marker.off("dragend", this.handleMarkerDrag);
        this.map.remove();
        this.map = null;
        this.marker = null;
      }
    } catch (e) {
      console.error(e);
    }
  },
  watch: {
    stepUser(newVal) {
      if (newVal == 3) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },
    notShowMap(newVal) {
      this.post_filds.feature.showmap = !newVal;
    },
    "$store.state.c_set": {
      handler() {
        if (this.mapInitStarted) return;
        this.mapInitStarted = true;
        this.$nextTick(() => {
          if (!this.mapInitialized) {
            this.initMap();
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    stepUser() {
      return this.$route.query.step || "1";
    },
    featuresModal() {
      return this.$route.query.features === "active";
    },
  },
  methods: {
    historyBackHanlder() {
      history.back();
    },
    showFeaturesModalHnalder() {
      this.$router.push({
        query: {
          ...this.$route.query,
          features: "active",
        },
      });
    },
    async handleFileChange(event) {
      const self = this;
      const files = event.target.files;

      const files_length = files.length + self.front_show.images.length;

      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      if (this.editIndex !== null) {
        const file = files[0];

        if (file) {
          if (file.size > 4 * 1024 * 1024) {
            toast(
              `حجم تصویر "${file.name}" بیشتر از 4 مگابایت است و آپلود نشد.`,
              {
                type: "error",
                dangerouslyHTMLString: true,
              },
            );
            return;
          }

          const reader = new FileReader();

          reader.onload = (e) => {
            self.front_show.images[self.editIndex] = e.target.result;
          };

          reader.readAsDataURL(file);

          self.post_filds.new_images[self.editIndex] = file;
          self.post_filds.images.splice(self.editIndex, 1, null);

          self.editIndex = null;
        }
      } else {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          if (file.size > 4 * 1024 * 1024) {
            toast(
              `حجم تصویر "${file.name}" بیشتر از 4 مگابایت است و آپلود نشد.`,
              {
                type: "error",
                dangerouslyHTMLString: true,
              },
            );
            continue;
          }

          const reader = new FileReader();

          reader.onload = (e) => {
            self.front_show.images.push(e.target.result);
          };

          reader.readAsDataURL(file);

          self.post_filds.new_images.push(file);
          self.post_filds.images.push(null);
        }
      }

      event.target.value = "";
    },

    removeImage(index) {
      const url = this.front_show.images[index];
      URL.revokeObjectURL(url);
      this.front_show.images.splice(index, 1);
      this.post_filds.images.splice(index, 1);
      this.post_filds.new_images.splice(index, 1);
    },

    setEditIndex(index) {
      this.editIndex = index;

      const input = document.getElementById("uploadImage");
      input.click();
    },

    async handleDrop(event) {
      const self = this;
      const files = event.dataTransfer.files;

      const files_length = files.length + self.front_show.images.length;

      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      await this.addImages(files);
    },

    async addImages(files) {
      const self = this;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size > 4 * 1024 * 1024) {
          toast(
            `حجم تصویر "${file.name}" بیشتر از 4 مگابایت است و آپلود نشد.`,
            {
              type: "error",
              dangerouslyHTMLString: true,
            },
          );
          continue;
        }

        const reader = new FileReader();

        // reader.onload = (e) => {
        //   self.front_show.images.push(e.target.result);
        // };
        self.front_show.images.push(URL.createObjectURL(file));

        reader.readAsDataURL(file);

        self.post_filds.new_images.push(file);
        self.post_filds.images.push(null);
      }
    },
    savePostHandler() {
      this.$swal
        .fire({
          title: "ویرایش آگهی",
          text: "لطفاً محل ثبت آگهی ویرایش شده خود را انتخاب کنید.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "منتشر شود",
          cancelButtonText: "آرشیو شود",
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.post_filds.status = "pending";
            this.submitPost();
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.post_filds.status = "draft";
            this.submitPost();
          }
        });
    },
    tooltipHandler() {
      this.showTooltip = !this.showTooltip;
    },
    handleResize() {
      this.dialogWidth = window.innerWidth < 768 ? "90%" : "600px";
    },
    querySearch(queryString, cb) {
      const results = queryString
        ? this.placeOptions.filter((place) => place.includes(queryString))
        : this.placeOptions;
      cb(results.map((place) => ({ value: place })));
    },
    addWalkItem() {
      if (this.post_filds.walkDistances.length > 0) {
        const last =
          this.post_filds.walkDistances[
            this.post_filds.walkDistances.length > 0
              ? this.post_filds.walkDistances.length - 1
              : 0
          ];
        if (last.property_title.trim() && last.property_time.trim()) {
          this.post_filds.walkDistances.push({
            property_title: "",
            property_time: "",
          });
        }
      } else {
        this.post_filds.walkDistances.push({
          property_title: "",
          property_time: "",
        });
      }
    },
    removeWalkItem(index) {
      this.post_filds.walkDistances.splice(index, 1);
    },
    addDriveItem() {
      if (this.post_filds.driveDistances.length > 0) {
        const last =
          this.post_filds.driveDistances[
            this.post_filds.driveDistances.length > 0
              ? this.post_filds.driveDistances.length - 1
              : 0
          ];
        if (last.property_title.trim() && last.property_time.trim()) {
          this.post_filds.driveDistances.push({
            property_title: "",
            property_time: "",
          });
        }
      } else {
        this.post_filds.driveDistances.push({
          property_title: "",
          property_time: "",
        });
      }
    },
    removeDriveItem(index) {
      this.post_filds.driveDistances.splice(index, 1);
    },
    getJalaliYears() {
      const faYear = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
      }).format(new Date());

      const enYear = this.convertPersianToEnglish(faYear);

      for (let i = +enYear; i >= 1370; i--) {
        this.years.push(i.toString());
      }
    },
    convertPersianToEnglish(str) {
      const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      return str
        .split("")
        .map((ch) => {
          const index = persianNumbers.indexOf(ch);
          return index > -1 ? englishNumbers[index] : ch;
        })
        .join("");
    },
    load_postInfo() {
      console.log("this.postId", this.postId);
      let self = this;
      self.helperGet("post-info?post_id=" + self.postId).then((r) => {
        console.log("r", r);
        self.post_filds = r.data.data;

        self.front_show = {
          building_area: this.formatPrice(r.data.data.building_area),
          building_area_max: this.formatPrice(r.data.data.building_area_max),
          passage_width: this.formatPrice(r.data.data.passage_width),
          land_area: this.formatPrice(r.data.data.land_area),
          mortgage_price: this.formatPrice(r.data.data.mortgage_price),
          mortgage_price_max: this.formatPrice(r.data.data.mortgage_price_max),
          rent_price: this.formatPrice(r.data.data.rent_price),
          rent_price_max: this.formatPrice(r.data.data.rent_price_max),
          meter_price: this.formatPrice(r.data.data.meter_price),
          total_price: this.formatPrice(r.data.data.total_price),
          total_price_max: this.formatPrice(r.data.data.total_price_max),
          width: this.formatPrice(r.data.data.width),
          district_list: [],
          images: [],
        };
        self.front_show.images = r.data.data.images_front;

        this.load_district();
        this.notShowMap = !r.data.data.feature.showmap;
        this.dataLoaded = true;
      });
    },
    featuresSelectHandler(feature) {
      if (!this.post_filds.facilities.includes(feature)) {
        this.post_filds.facilities.push(feature);
      } else {
        this.post_filds.facilities = this.post_filds.facilities.filter(
          (f) => f !== feature,
        );
      }
    },
    featuresRemoveHandler(event, feature) {
      event.stopPropagation();
      this.post_filds.facilities = this.post_filds.facilities.filter(
        (f) => f !== feature,
      );
    },

    closeBtnPush() {
      document.body.style = "overflow: auto;";
      if (this.$store.state.auth.role == "customer") {
        this.$router.push("/user-profile");
      } else {
        this.$router.push("/profile");
      }
      // if (this.previousRote) {
      //  this.$router.push(this.previousRote)
      // } else {
      //   this.$router.push("/")
      // }
      this.clearform();
    },

    inputFocusHandler(inputName) {
      this.isFocus = inputName;
    },

    initMap() {
      if (this.mapInitialized) return;
      try {
        if (!document.getElementById("map")) {
          setTimeout(() => this.initMap(), 50);
          return;
        }
        if (this.map) {
          this.map.off();
          this.map.remove();
          this.map = null;
        }
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        });
        const mapirToken =
          this.$store.state.c_set?.map_info?.mapir_key ||
          this.$store.state.c_set?.mapir_key ||
          "";
        this.map = L.map("map", {
          center: this.defaultCenter,
          zoom: this.defaultZoom,
          maxZoom: 19,
        });
        if (mapirToken) {
          L.maplibreGL({
            style: `https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=${mapirToken}`,
            transformRequest: (url) => {
              if (url.includes('map.ir') && !url.includes('x-api-key')) {
                const sep = url.includes('?') ? '&' : '?';
                return { url: url + sep + `x-api-key=${mapirToken}` };
              }
              return { url };
            }
          }).addTo(this.map);
        } else {
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(this.map);
        }
        const existsLat = parseFloat(this.post_filds?.latitude);
        const existsLng = parseFloat(this.post_filds?.longitude);
        const initialPos = (existsLat && existsLng) ? [existsLat, existsLng] : this.defaultCenter;
        this.marker = L.marker(initialPos, { draggable: true }).addTo(this.map);
        this.marker.on("dragend", this.handleMarkerDrag);
        this.map.on("click", this.handleMapClickLeaflet);
        if (existsLat && existsLng) {
          this.map.setView(initialPos, this.defaultZoom);
          this.updateAddress(existsLat, existsLng);
        }
        this.map.whenReady(() => {
          setTimeout(() => {
            try { this.map.invalidateSize(); } catch (e) { console.error(e); }
          }, 100);
        });
        this.mapInitialized = true;
      } catch (err) {
        console.error("initMap error:", err);
      }
    },

    handleMapClickLeaflet(e) {
      const lat = e.latlng.lat;
      const lng = e.latlng.lng;
      this.placeMarkerAndUpdate(lat, lng);
    },

    handleMarkerDrag(e) {
      const pos = e.target.getLatLng();
      this.placeMarkerAndUpdate(pos.lat, pos.lng);
    },

    placeMarkerAndUpdate(lat, lng) {
      this.post_filds = this.post_filds || {};
      this.post_filds.latitude = parseFloat(lat);
      this.post_filds.longitude = parseFloat(lng);
      if (this.marker) {
        this.marker.setLatLng([lat, lng]);
      } else {
        this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
        this.marker.on("dragend", this.handleMarkerDrag);
      }
      try {
        this.map.setView([lat, lng], Math.max(this.map.getZoom(), 14));
      } catch (e) {
        console.error(e);
      }
      this.updateAddress(lat, lng);
    },

    async updateAddress(lat, lng) {
      try {
        const mapirToken =
          this.$store.state.c_set?.map_info?.mapir_key ||
          this.$store.state.c_set?.mapir_key ||
          "";
        const response = await axios.get(
          `https://map.ir/reverse/?lat=${lat}&lon=${lng}`,
          {
            headers: {
              "x-api-key": mapirToken,
            },
          },
        );
        let persianAddress = "";

        if (response.data && response.data.address) {
          const a = response.data.address;
          const parts = [a.province, a.city, a.suburb, a.neighbourhood, a.road].filter(Boolean);
          if (parts.length) persianAddress = parts.join("، ");
        }
        if (!persianAddress && response.data && response.data.formatted_address) {
          persianAddress = response.data.formatted_address;
        }
        if (!persianAddress) persianAddress = "آدرس نامشخص";
        if (!this.post_filds) this.post_filds = {};
        if (!this.post_filds.address) {
          this.post_filds.address = persianAddress;
        }
        this.post_filds.mapAddress = persianAddress;
      } catch (err) {
        console.error("updateAddress error (map.ir):", err);
        if (!this.post_filds) this.post_filds = {};
        this.post_filds.mapAddress = "خطا در دریافت آدرس";
      }
    },

    async searchLocation() {
      if (!this.searchQuery) return;

      const mapirToken = this.$store.state.c_set?.map_info?.mapir_key || this.$store.state.c_set?.mapir_key;
      const query = `${this.searchQuery.trim()} بابل`;
      try {
        const resp = await axios.get("https://map.ir/search/v2", {
          params: { text: query },
          headers: {
            "x-api-key": mapirToken,
          },
        });
        const items = resp.data?.items || resp.data?.values || [];
        if (!items.length) return;
        const item = items[0];
        const loc = item.location || item.geometry || null;
        if (!loc) return;
        const lat = parseFloat(loc.lat ?? loc.y);
        const lon = parseFloat(loc.lng ?? loc.x ?? loc.lon);
        if (!lat || !lon) return;
        this.map.setView([lat, lon], 16);
        if (this.marker) {
          this.marker.setLatLng([lat, lon]);
        } else {
          this.marker = L.marker([lat, lon], { draggable: true }).addTo(this.map);
          this.marker.on("dragend", this.handleMarkerDrag);
        }
        this.updateAddress(lat, lon);
      } catch (err) {
        console.error("searchLocation error (map.ir):", err);
      }
    },

    mapGetCenter() {
      if (!this.map) return null;
      const c = this.map.getCenter();
      return { lat: c.lat, lng: c.lng };
    },
    closeBtn() {
      if (this.$store.state.auth.role == "customer") {
        this.$router.push("/user-profile");
      } else {
        this.$router.push("/profile");
      }
      // if (this.previousRote) {
      //  this.$router.push(this.previousRote)
      // } else {
      //   this.$router.push("/")
      // }
      document.body.style = "overflow-y: auto;";
      this.clearform();
    },
    StepClickBox() {
      console.log("ee", this.front_show.images);
      const validation = this.checkvalidation();
      if (!validation) return;
      if (this.stepUser != 3) {
        if (this.stepUser == 2) {
          if (this.post_filds.main_category == "request") {
            if (
              this.$store.state.auth.role == "branch_admin" ||
              this.$store.state.auth.role == "consultant"
            ) {
              this.savePostHandler();
            } else {
              this.submitPost();
            }
            return;
          }
          if (this.front_show.images.length == 0) {
            toast(
              "برای ادامه فرآیند ثبت آگهی، بارگذاری حداقل یک تصویر الزامی است",
              {
                type: "error",
              },
            );
            return;
          }
          this.isLoading = true;

          setTimeout(() => {
            this.initMap();
          }, 2000);
        }
        if (this.post_filds.main_category == "request") {
          this.submitPost();
        } else {
          // this.stepUser += 1;
          let currentStep = Number(this.$route.query.step) || 1;
          let nextStep = currentStep + 1;
          this.$router.push({
            query: {
              ...this.$route.query,
              step: nextStep,
            },
          });
        }
      } else {
        if (this.post_filds.latitude == "" || this.post_filds.longitude == "") {
          toast("لطفاً موقعیت مکانی خود را روی نقشه انتخاب کنید", {
            type: "error",
          });
          return;
        }
        if (
          this.$store.state.auth.role == "branch_admin" ||
          this.$store.state.auth.role == "consultant"
        ) {
          if (this.post_filds.main_category == "request") {
            this.submitPost();
          } else {
            this.savePostHandler();
          }
        } else {
          this.submitPost();
        }
      }
    },
    submitPost() {
      let self = this;
      this.btn_loading = true;
      axios
        .post(self.$store.getters.baseUrl + "/update-post", self.post_filds, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + self.$store.getters.appToken,
          },
        })
        .then(function (response) {
          console.log("response", response);
          if (response.data.result == "1") {
            toast(response.data.msg, {
              type: "success",
              dangerouslyHTMLString: true,
            });
            self.clickFalse = false;
            self.closeBtn();
            self.$emit("reloadPosts");
          } else {
            toast(response.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          self.btn_loading = false;
        })
        .catch((error) => {
          toast(
            "درحال حاضر ارتباط با سرور مقدور نیست؛ لطفا دقایقی دیگر امتجان کنید.",
            {
              type: "error",
              dangerouslyHTMLString: true,
            },
          );
          console.error(error);
          self.btn_loading = false;
        });
    },

    //submitPost() {
    //  let self = this;
    //  this.btn_loading = true;
    //
    //  const formData = new FormData()
    //
    //  Object.keys(this.post_filds).forEach((key) => {
    //    if (key !== "images" && key !== "new_images") {
    //      if (Array.isArray(this.post_filds[key])) {
    //        this.post_filds[key].forEach((item) => {
    //          formData.append(`${key}[]`, item);
    //        });
    //      } else if (
    //        typeof this.post_filds[key] === "object" &&
    //        this.post_filds[key] !== null
    //      ) {
    //        formData.append(key, JSON.stringify(this.post_filds[key]));
    //      } else {
    //        formData.append(key, this.post_filds[key] ?? "");
    //      }
    //    }
    //  });
    //  this.post_filds.images.forEach((file) => {
    //    formData.append("images[]", file, file.name);
    //  });
    //  this.post_filds.new_images.forEach((file) => {
    //    formData.append("new_images[]", file, file.name);
    //  });
    //  axios
    //    .post(self.$store.getters.baseUrl + "/update-post", formData, {
    //      headers: {
    //        // Set the content type for file upload
    //        Authorization: "Bearer " + self.$store.getters.appToken,
    //      },
    //    })
    //    .then(function (response) {
    //      console.log("response", response);
    //      if (response.data.result == "1") {
    //        toast(response.data.msg, {
    //          type: "success",
    //          dangerouslyHTMLString: true,
    //        });
    //        self.clickFalse = false;
    //        self.closeBtn();
    //        self.$emit("reloadPosts");
    //      } else {
    //        toast(response.data.msg, {
    //          type: "error",
    //          dangerouslyHTMLString: true,
    //        });
    //      }
    //      self.btn_loading = false;
    //    })
    //    .catch((error) => {
    //      toast("خطای غیر منتظره رخ داد. مجدد تلاش کنید!",{
    //          type: "error",
    //          dangerouslyHTMLString: true,
    //        },
    //      );
    //      console.error(error);
    //      self.btn_loading = false;
    //    });
    //},
    clearform() {
      ((this.post_filds = {
        content: "",
        request_type: "buy",
        name: "",
        completion_date: "",
        completion_date_max: "",
        doc_type: "0",
        main_category: "trade",
        category: "apartment",
        sub_category: "",
        building_area: "",
        building_area_max: "",
        land_area: "",
        land_area_max: "",
        floor: "",
        mortgage_price: 0,
        mortgage_price_max: 0,
        rent_price: 0,
        rent_price_max: 0,
        meter_price: 0,
        total_price: 0,
        total_price_max: 0,
        width: "",
        bedroom: "",
        floor_units: "",
        total_floor: "",
        parking: "",
        elevator: "",
        building_license_date: "",
        storage: "",
        passage_width: "",
        district: null,
        districts: [],
        state: 26,
        city: 317,
        images: [],
        address: "",
        mapAddress: "",
        latitude: "",
        longitude: "",
        details: "",
        contact: "",
        facilities: [],
        status: "pending",
        feature: {
          showphone: false,
          exchangeable: false,
          convertable: false,
          furnished: false,
          student: false,
          single: false,
          fast: false,
          showmap: true,
          reBuild: false,
          pet: false,
          dayli_rent: false,
          inbaft: false,
          outbaft: false,
          pilot: false,
          seatBottom: false,
          liveable: false,
          workEnd: false,
        },
        walkDistances: [],
        driveDistances: [],
        archive_desc: "",
        owner_tel: "",
      }),
        (this.front_show = {
          facilities: [],
          sub_category_list: [],
          building_area: "",
          building_area_max: "",
          passage_width: "",
          land_area: "",
          land_area_max: "",
          mortgage_price: 0,
          mortgage_price_max: 0,
          rent_price: 0,
          rent_price_max: 0,
          meter_price: 0,
          total_price: 0,
          total_price_max: 0,
          width: "",
          district_list: [],
          images: [],
        }));
    },
    checkvalidation() {
      let text = "";
      let status = false;
      if (this.post_filds.content == "") {
        text = "عنوان آگهی اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.request_type == "" &&
        this.post_filds.main_category == "request"
      ) {
        text = "نوع درخواست اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.land_area == "" &&
        (this.post_filds.category === "villa_house" ||
          this.post_filds.category === "garden" ||
          this.post_filds.category === "land")
      ) {
        text =
          this.post_filds.main_category == "request"
            ? "حداقل متراژ زمین اجباری می باشد"
            : "متراژ زمین اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.land_area_max == "" &&
        (this.post_filds.category === "villa_house" ||
          this.post_filds.category === "garden" ||
          this.post_filds.category === "land")
      ) {
        text = "حداکثر متراژ زمین اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.building_area == "" &&
        this.post_filds.category !== "garden" &&
        this.post_filds.category !== "land"
      ) {
        text =
          this.post_filds.main_category == "request"
            ? "حداقل متراژ اجباری می باشد"
            : "متراژ اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.building_area_max == "" &&
        this.post_filds.category !== "garden" &&
        this.post_filds.category !== "land"
      ) {
        text = "حداکثر متراژ اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.completion_date == "" &&
        this.post_filds.category !== "garden" &&
        this.post_filds.category !== "land"
      ) {
        text =
          this.post_filds.main_category == "request"
            ? "حداقل سال ساخت اجباری می باشد"
            : "سال ساخت اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.completion_date_max == "" &&
        this.post_filds.category !== "garden" &&
        this.post_filds.category !== "land"
      ) {
        text = "جداکثر سال ساخت اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.doc_type == "0" &&
        this.post_filds.main_category != "rent" &&
        this.post_filds.request_type != "rent"
      ) {
        text = "نوع سند اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.bedroom == "" &&
        this.post_filds.category !== "commercial" &&
        this.post_filds.category !== "industrial" &&
        this.post_filds.category !== "garden" &&
        this.post_filds.category !== "land"
      ) {
        text = "تعداد اتاق اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.address === "" &&
        this.post_filds.main_category != "request"
      ) {
        text = "آدرس اجباری می باشد";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.name == ""
      ) {
        text = "نام اجباری می باشد";
        status = true;
      } else if (this.post_filds.contact == "") {
        text = "تلفن تماس اجباری می باشد";
        status = true;
      } else if (!/^09\d{9}$/.test(this.post_filds.contact)) {
        text = "فرمت شماره موبایل وارد شده صحیح نمی باشد";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "buy" &&
        this.post_filds.total_price == ""
      ) {
        text = "لطفا حداقل قیمت مورد نظر خود راوارد کنید";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "buy" &&
        this.post_filds.total_price_max == ""
      ) {
        text = "لطفا حداکثر قیمت مورد نظر خود راوارد کنید";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "rent" &&
        this.post_filds.mortgage_price == ""
      ) {
        text = "لطفا حداقل مبلغ رهن مورد نظر خود راوارد کنید";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "rent" &&
        this.post_filds.mortgage_price_max == ""
      ) {
        text = "لطفا حداکثر مبلغ رهن مورد نظر خود راوارد کنید";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "rent" &&
        this.post_filds.rent_price == ""
      ) {
        text = "لطفا حداقل مبلغ اجاره مورد نظر خود راوارد کنید";
        status = true;
      } else if (
        this.post_filds.main_category == "request" &&
        this.post_filds.request_type == "rent" &&
        this.post_filds.rent_price_max == ""
      ) {
        text = "لطفا حداکثر مبلغ اجاره مورد نظر خود راوارد کنید";
        status = true;
      } else if (!this.$store.state.auth.loggedIn) {
        text = "برای ثبت آگهی ابتدا وارد حساب کاربری خود شوید";
        status = true;
      } else if (
        this.$store.state.auth.loggedIn &&
        !this.$store.state.auth.is_complate
      ) {
        text = "برای ثبت آگهی ابتدا اطلاعات پروفایل خود را تکمیل کنید";
        status = true;
      } else if (
        this.$store.state.auth.loggedIn &&
        this.$store.state.auth.role == "builder" &&
        this.$store.state.auth.is_allowed == "no"
      ) {
        text = "احراز هویت شما به طور کامل انجام نشده است";
        status = true;
      } else if (
        this.$store.state.auth.loggedIn &&
        this.$store.state.auth.role == "branch_admin" &&
        this.branchInfo.is_allowed != "active"
      ) {
        text = "احراز هویت شما به طور کامل انجام نشده است";
        status = true;
      }

      if (status) {
        toast(text, {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      }
      return true;
    },
    ShowToUser() {
      document.body.style = "overflow: hidden;";
    },
    showCategoryHandler() {
      this.$router.push("/category?main_cat=all&cat=all");
      this.stepUser = 1;
      document.body.style = "overflow: auto;";
      this.$emit("close");
    },
    get_sub_category() {
      let self = this;
      this.helperGet("get-post-sub-category", "category=land").then((r) => {
        self.front_show.sub_category_list = r.data.rows;
        if (r.data.rows.length > 0)
          self.post_filds.sub_category = r.data.rows[0].value;
      });
    },
    load_district() {
      let self = this;
      this.helperGet("get-district?id=317").then((r) => {
        self.front_show.district_list = r.data;
      });

      this.get_sub_category();
    },
    setformatPrice(event, param) {
      this.front_show[param] = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, ""),
      );
      this.post_filds[param] = event.target.value.replace(/[^\d.-]/g, "");
    },
    select_main_category() {
      this.post_filds.mortgage_price = 0;
      this.post_filds.rent_price = 0;
      this.post_filds.meter_price = 0;
      this.post_filds.total_price = 0;
      this.front_show.meter_price = 0;
      this.front_show.mortgage_price = 0;
      this.front_show.rent_price = 0;
      if (this.post_filds.main_category == "rent")
        this.post_filds.request_type = "rent";
      else this.post_filds.request_type = "buy";
    },
    select_category() {
      this.post_filds.land_area = "";
      this.post_filds.sub_category = "0";
      this.front_show.land_area = "";
      this.front_show.facilities = [];
      this.post_filds.facilities = [];

      let self = this;
      this.helperGet(
        "get-facilities",
        "category=" + self.post_filds.category,
      ).then((r) => {
        if (r.data.result == 1) self.front_show.facilities = r.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.numberInput {
  text-align: left !important;
  direction: ltr !important;
}
.loader {
  width: 25px !important;
  height: 25px !important;
  margin-bottom: 5px;
}
.map {
  height: 100% !important;
}
.text-danger {
  color: #ef2323;
}
.fs-14 {
  font-size: 14px;
}

.remove-button,
.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: #fff;
    font-size: 14px;
  }
}

.IconLineTopAllPwaMobile .createMelkStepIcon {
  position: relative;
  border-width: 2px;
  border-style: solid;
  z-index: 1 !important;
}

.setpIconsLine {
  width: 160%;
  height: 2px;
  margin-top: 30px;
  margin-right: -30%;
  z-index: 0;
  border-radius: 10px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
}
.image-preview {
  border: 1px solid rgb(216, 239, 246);
  box-shadow: 0 0 14px rgba(0, 150, 199, 0.1);
}

.textareaShowMApDetails {
  margin-bottom: 24px;

  textarea {
    border: 1px solid rgb(216, 239, 246);
    box-shadow: 0 0 14px rgba(0, 150, 199, 0.1);
  }
}

.createMelkContainer {
  margin: 64px auto 48px;
  width: 90%;
  min-height: 100vh;
  background: #fff;
  border-radius: 8px;
  padding: 24px 0;
  border: 1px solid #ddd;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);

  .createMelkStepIcons {
    position: static !important;
    background: transparent;
    padding-bottom: 10px;
    margin: auto;
  }

  .createMelktitleWrapper {
    position: static !important;
    display: block;
    padding: 0;
    width: 100%;
    height: 70px;
    background: #fff;

    .titleContainer {
      position: relative;
      width: 90%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;

      .createMelkTitle {
        font-family: "yekan", sans-serif;
        font-size: 1.6rem;
        font-weight: 600;
      }
    }
  }

  .formOuterContainer {
    .createMelkFormContainer {
      width: 90% !important;
      margin: auto;

      &.containerGrid {
        margin-top: 48px;
        display: grid;
        grid-template-columns: repeat(3, 31%);
        justify-content: space-between;
      }
    }

    .createMelkFormSwitches {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(5, 20%);
      margin-bottom: 38px;

      .switchBox {
        display: flex;
        align-items: center;
        margin-right: 16px;
        gap: 12px;

        .switchTitle {
          font-size: 13px;
        }
      }
    }

    .ChildShowInputFormToUser {
      position: relative;
      width: 100%;
      background: #fff;
      border-radius: 6px;
      margin-bottom: 38px;

      &.mobileDesc {
        display: none;
      }

      &.desktopDesc {
        display: block;
      }

      &.textareaInput {
        margin-bottom: 24px !important;
      }

      &.focused {
        label {
          width: auto;
          top: 0;
          font-size: 14px !important;
          color: rgb(0, 150, 199);
          background: #fff;

          &.textareLabel {
            width: auto !important;
            top: 0;
          }
        }

        input,
        select,
        textarea,
        .featuresUnputBox,
        :deep(.formSelectInput .el-select__wrapper) {
          background: #fff !important;
          border: 1px solid #0096c7 !important;
        }
      }

      &.done {
        label {
          width: auto;
          top: 0;
          font-size: 12px;
          background: #fff;

          &.textareLabel {
            width: auto !important;
            top: 0;
          }
        }

        input,
        select,
        textarea,
        .featuresUnputBox,
        :deep(.formSelectInput .el-select__wrapper) {
          background: #fff !important;
          border: 1px solid #dcdfe6;
        }
      }

      label {
        font-family: "iranyekanB", sans-serif;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        padding: 0 6px;
        background: #fff;
        width: 80%;
        margin: 0;
        font-size: 12px;
        transition: all 0.15s ease-in-out;
        pointer-events: none;
        z-index: 2;

        &.textareLabel {
          top: 24px;
        }
      }

      input,
      select,
      textarea,
      .featuresUnputBox,
      :deep(.formSelectInput .el-select__wrapper) {
        position: relative;
        width: 100%;
        padding: 12px;
        font-size: 14px !important;
        transition: all 0.15s ease-in-out;
        z-index: 1;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        background: #fff !important;
        box-shadow: none !important;
        resize: none;

        &:focus {
          outline: none;
        }
      }

      input,
      select,
      .featuresUnputBox,
      :deep(.formSelectInput .el-select__wrapper) {
        height: 50.4px;
      }

      :deep(.formSelectInput .el-select__selection) {
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      input,
      select,
      :deep(.formSelectInput .el-select__wrapper) {
        height: 50.4px !important;

        .el-select__placeholder {
          position: static !important;
          transform: translateY(0) !important;
        }
      }
    }

    .ShowBoxBtnClick {
      margin-top: 8px;
    }
  }
}

.featuresListContainer {
  width: 94%;
  max-height: 284px;
  padding-bottom: 40px;
  overflow-y: auto;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding-top: 4px;
  gap: 12px;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .featuresBtn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 5px 16px;
    font-size: 14px;
    border: 1px solid #b6b6b6;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.05s;

    i,
    span {
      display: none !important;
    }

    i {
      width: 16px;
      height: 16px;
      background: transparent;
      align-items: center;
      justify-content: center;
      transition: all 0.15s;
      border-radius: 50%;
      cursor: pointer;
      opacity: 0;
      pointer-events: none;

      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }
    }

    &:active {
      transform: scale(0.95);
    }

    &.selected {
      border: 1px solid #0096c7;
      color: #fff;
      background: #0096c7;

      i {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
}

.featuresUnputBox {
  overflow: hidden;
}

.swiper-wrapper {
  display: flex;
  flex-wrap: nowrap !important;
}

.feautureThumb {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  padding: 4px 8px;
  background: #0096c7;
  color: #fff;
  font-size: 12px;
  margin-left: 6px;
  border-radius: 6px;

  i {
    display: flex;
    width: 16px;
    height: 16px;
    background: transparent;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.4);
    }
  }
}
.swiper-slide {
  width: auto !important;
}

.featuresSubmitBtn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  margin: 0 auto;
  width: 90%;
  height: 48px;
  background: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
}

@media screen and (max-width: 1100px) {
  .TopShowBackToPage {
    background: #fff;
    box-shadow: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (max-width: 992px) {
  .createMelkContainer {
    .formOuterContainer {
      .createMelkFormContainer.containerGrid {
        grid-template-columns: repeat(3, 31%) !important;
      }

      .createMelkFormSwitches {
        grid-template-columns: repeat(3, 1fr);

        .switchBox {
          margin-bottom: 16px;

          .switchTitle {
            width: 86px;
          }
        }
      }
    }
  }
}

@media (max-width: 868px) {
  .createMelkContainer {
    .formOuterContainer {
      .createMelkFormContainer.containerGrid {
        grid-template-columns: repeat(2, 48%) !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .setpIconsLine {
    width: 260%;
    margin-right: -70%;
  }

  .createMelkContainer {
    margin: 0;
    width: 100%;
    padding-top: 0;

    .TopShowBackToPage {
      box-shadow: none;
    }
  }
}

@media (max-width: 576px) {
  .createMelkContainer {
    margin: 0;
    width: 100%;
    padding-top: 0;

    .TopShowBackToPage {
      box-shadow: none;
    }

    .formOuterContainer {
      .createMelkFormContainer {
        width: 90% !important;
        padding-right: 0 !important;
        padding-left: 0 !important;

        &:last-of-type {
          margin-bottom: 24px;
        }

        &.containerGrid {
          grid-template-columns: 100% !important;
        }

        .ChildShowInputFormToUser {
          &.mobileDesc {
            display: block;
            margin-bottom: 38px !important;
          }

          &.desktopDesc {
            display: none;
          }
        }
      }

      .createMelkFormSwitches {
        grid-template-columns: 50% 50%;
      }
    }
  }
}

.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  width: 54px;
  height: 26px;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #f4f3f3;
  transition: 0.3s ease all;
  z-index: 1;
}
/* Button 3 */
#button-3 .knobs:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 18px;
  height: 18px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  background-color: #b7b7b7;
  border-radius: 50%;
  transition:
    0.15s ease all,
    left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

#button-3 .checkbox:active + .knobs:before {
  width: 46px;
  border-radius: 100px;
}

#button-3 .checkbox:checked:active + .knobs:before {
  margin-left: -26px;
}

#button-3 .checkbox:checked + .knobs:before {
  left: 32px;
  background-color: #0096c7;
}

#button-3 .checkbox:checked ~ .layer {
  background-color: #ebf7fc;
}

.map-container {
  position: relative;
  width: 100%;
  height: 500px;
  margin-bottom: 24px;
}

.leaflet-map {
  width: 100%;
  height: 100% !important;
  border-radius: 8px;
  overflow: hidden;
}

.map-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.map-address {
  margin-top: 14px;
  margin-bottom: 18px;

  .realLocationWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 0.9rem;
    padding-right: 12px;
    margin-top: 4px;
  }

  .address-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    resize: none;
    font-size: 14px;

    &:focus {
      outline: none;
    }
  }
}

.search-box {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  z-index: 1050;

  .search-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    font-size: 14px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    padding: 8px 16px;
    background: #0096c7;
    border: none;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: darken(#0096c7, 10%);
    }
  }
}

#map {
  width: 100%;
  height: 400px !important;
  z-index: 1;
}

.ShowBoxBtnClick {
  &.mt24 {
    margin-top: 24px !important;
  }
}

.registrationOutputMessage {
  width: 100%;
  padding: 0 16px;
  height: 310px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.35em;
}

@media (max-width: 500px) {
  .map-address {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}

.filterTooltip {
  width: 100%;
  padding: 12px;
  border-radius: 0.375rem;
  border: 1px solid #0096c7;
  color: #0096c7;
  font-size: 0.8rem;
  line-height: 1.5rem;
  text-align: justify;
  background: rgb(229, 240, 255);
  margin: -8px 0 16px;
}

.focused,
.done {
  .customLabel {
    &::before {
      opacity: 1;
    }
  }
}

.customLabel {
  position: relative;

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 50%;
    background: #edeffd;
    position: absolute;
    inset-inline: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    transition: all 0.15s ease-in-out;
  }

  span {
    position: relative;
    z-index: 2;
  }
}
.dark {
  .featuresControl {
    .controlOverlay {
      background: rgba(3, 8, 13, 0.72);
    }

    .controlContent {
      background: #18242f;
      box-shadow:
        0 -10px 40px rgba(0, 0, 0, 0.3),
        0 -2px 12px rgba(0, 0, 0, 0.2);

      .contentHandler {
        .handlerThumb {
          background: #3b4752;
        }
      }

      .contentContainer {
        .containerHeader {
          .headerTitleWrapper {
            .headerTitle {
              color: #f5f7fa;
            }

            .headerDesc {
              color: #32b5df;
            }
          }
        }

        .containerMain {
          .mainFeatures {
            .featuresThumb {
              border-color: #33414d;
              background: #1f2b35;
              color: #c0cad3;

              &.selected {
                border-color: #32b5df;
                background: rgba(50, 181, 223, 0.12);
                color: #32b5df;
              }
            }
          }
        }

        .containerFooter {
          border-top-color: #2b3742;

          .footerSubmit {
            background: #32b5df;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.featuresControl {
  position: fixed;
  z-index: 9999;
  inset: 0;
  width: 100%;
  height: 100dvh;
  pointer-events: none;
  &.active {
    pointer-events: auto;
    visibility: visible;
    .controlOverlay {
      opacity: 1;
      backdrop-filter: blur(10px);
    }
    .controlContent {
      transform: translateY(0);
      animation: sheetIn 0.55s cubic-bezier(0.22, 1, 0.36, 1);
    }
  }
  .controlOverlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.42);
    opacity: 0;
    backdrop-filter: blur(0px);
    transition:
      opacity 0.45s ease,
      backdrop-filter 0.45s ease;
  }
  .controlContent {
    position: absolute;
    inset: auto 0 0 0;
    background: #fff;
    padding-top: 10px;
    border-radius: 22px 22px 0 0;
    box-shadow:
      0 -10px 40px rgba(0, 0, 0, 0.08),
      0 -2px 12px rgba(0, 0, 0, 0.04);
    will-change: transform, opacity;
    transform: translateY(110%);
    transform-origin: bottom center;
    transition:
      transform 0.55s cubic-bezier(0.22, 1, 0.36, 1),
      opacity 0.45s ease;
    .contentHandler {
      padding-block: 4px 18px;
      .handlerThumb {
        width: 42px;
        height: 4px;
        border-radius: 9999px;
        margin-inline: auto;
        background: #e3dbe0;
      }
    }
    .contentContainer {
      padding: 0 20px 24px;
      .containerHeader {
        margin-bottom: 16px;
        .headerTitleWrapper {
          text-align: center;
          .headerTitle {
            font-size: 1.25rem;
            font-family: "iranyekanB", sans-serif;
          }
          .headerDesc {
            font-size: 0.825rem;
            color: #0096c7;
            margin-top: -6px;
            font-family: "iranyekanB", sans-serif;
          }
        }
      }
      .containerMain {
        height: 314px;
        overflow-y: auto;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .mainFeatures {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
          padding-bottom: 16px;
          .featuresThumb {
            width: 100%;
            height: 40px;
            padding: 8px;
            border: 1px solid #c8c8c8;
            border-radius: 9999px;
            font-size: 0.8rem;
            font-family: "iranyekanB", sans-serif;
            display: grid;
            place-items: center;
            color: #767676;
            text-align: center;
            transition: transform 0.15s ease;
            &:active {
              transform: scale(0.95);
            }
            &.selected {
              border-color: #0096c7;
              color: #0096c7;
              background: #f1f8fe;
            }
          }
        }
      }
      .containerFooter {
        padding-top: 16px;
        border-top: 1px solid #f1f1f1;
        .footerSubmit {
          width: 100%;
          height: 48px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          font-size: 0.9rem;
          font-family: "iranyekanB", sans-serif;
          color: #fff;
          background: #0096c7;
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  .featuresControl {
    &.active {
      .controlContent {
        transform: translate(-50%, -50%);
        opacity: 1;
      }
    }
    .controlContent {
      inset: 50% auto auto 50%;
      max-width: 512px;
      width: 90%;
      margin-inline: auto;
      transform: translate(-50%, -42%);
      opacity: 0;
      border-radius: 16px;
      transition:
        transform 0.45s cubic-bezier(0.22, 1, 0.36, 1),
        opacity 0.35s ease;
      .contentHandler {
        display: none;
      }
      .contentContainer {
        padding: 0 24px 24px;
      }
    }
  }
}
</style>
